import VideoBox from 'component/VideoBoxVertical'

import { Wrapper } from './Styled'
import { memo } from 'react'

interface Template18Props {
  videoData?: any[]
}

/**
 * 模板 ID: "18": 豎版三個半向左滑動
 * */
function Template18({ videoData }: Template18Props) {
  return (
    // 因這裡有滑動事件, 設定.swiper-no-swiping 禁止CMS View的左右滑動切換頻道功能
    <Wrapper className={'swiper-no-swiping'}>
      {videoData?.map((item, i) => {
        return <VideoBox key={i} videoInfo={item} columns={3.5} allowUnload />
      })}
    </Wrapper>
  )
}

export default memo(Template18)
